import Components from "../components";

// This component is meant to replace the good old "select box that does a form-submit on select"
// You use a bootstrap dropdown, and fill it with rails remote links. This component swaps out the
// dropdown's trigger text when you select an item. It also closes the dropdown, as rails-jquery-ujs
// swallows the click event, so it never makes it to BS.
class DropdownWithRemoteLinks extends Components.Base {
  bind() {
    this.on("ajax:complete", (...args) => this.closeDropdown(...args));
  }

  closeDropdown(event) {
    const response = event.originalEvent.detail[0];
    if (response.status === 200 || response.status === 201) {
      this.$el
        .find(".dropdown-toggle")
        .html(
          event.target.getAttribute("data-description") ||
            event.target.innerHTML,
        );
    }
  }
}

Components.collection.register({
  selector: ".c-dropdown-with-remote-links",
  klass: DropdownWithRemoteLinks,
});
